import React, { useEffect, useState } from "react";
import Nav from "../../compontents/Nav";
import { toast } from "react-toastify";
import api from "../../services/api";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import { LuSearch, LuChevronLeft, LuChevronRight } from "react-icons/lu";
import { FaEye } from "react-icons/fa";

const StrategyDetailsModal = ({ order, isOpen, onClose }) => {
  if (!isOpen || !order) return null;

  const orderItems = order.order_items || [];
  const isClosed = order.status === "CLOSED";
  const displayPnl = isClosed ? order.realized_pnl || order.pnl : order.pnl;

  return (
    <>
      <div
        className="modal fade show d-block"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Strategy Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              {/* Header Info */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <p className="mb-1">
                    <strong>Strategy Type:</strong>{" "}
                    {order.strategy_type || "N/A"}
                  </p>
                  <p className="mb-1">
                    <strong>Status:</strong>
                    <span
                      className={`badge ms-2 ${
                        order.status === "CLOSED"
                          ? "bg-secondary"
                          : order.status === "OPEN"
                          ? "bg-success"
                          : "bg-warning"
                      }`}
                    >
                      {order.status}
                    </span>
                  </p>
                  <p className="mb-1">
                    <strong>Created:</strong> {order.created_at || "-"}
                  </p>
                  {isClosed && (
                    <p className="mb-1">
                      <strong>Closed:</strong> {order.closed_at || "-"}
                    </p>
                  )}
                </div>
                <div className="col-md-6 text-md-end">
                  <p className="mb-1">
                    <strong>Invested:</strong>{" "}
                    {order.invested_amount
                      ? `₹${Number(order.invested_amount).toFixed(2)}`
                      : "-"}
                  </p>
                  <p className="mb-1 fs-5">
                    <strong>Net P/L: </strong>
                    <span
                      className={
                        displayPnl >= 0 ? "text-success" : "text-danger"
                      }
                    >
                      ₹{Number(displayPnl || 0).toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>

              {/* Parameters / Limits */}
              <div className="row mb-4 bg-light p-3 rounded mx-0">
                <div className="col-6">
                  <small className="text-muted d-block">Max Profit Est.</small>
                  <strong className="text-success">₹{order.max_profit}</strong>
                </div>
                <div className="col-6">
                  <small className="text-muted d-block">Max Loss Est.</small>
                  <strong className="text-danger">₹{order.max_loss}</strong>
                </div>
              </div>

              {/* Order Items Table */}
              {orderItems.length > 0 && (
                <div className="mb-4">
                  <h6 className="fw-bold border-bottom pb-2 mb-3">
                    Order Items
                  </h6>
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>Symbol</th>
                          <th>Action</th>
                          <th>Qty</th>
                          <th>Entry Price</th>
                          <th>Exit Price</th>
                          <th>P/L</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderItems.map((item, idx) => {
                          const itemPnl =
                            item.position_status === "CLOSED"
                              ? item.realized_pnl
                              : item.pnl;
                          return (
                            <tr key={item.id || idx}>
                              <td className="small">{item.symbol}</td>
                              <td>
                                <span
                                  className={
                                    item.action === "BUY"
                                      ? "text-success fw-bold"
                                      : "text-danger fw-bold"
                                  }
                                >
                                  {item.action}
                                </span>
                              </td>
                              <td>{item.quantity}</td>
                              <td>
                                ₹{Number(item.opening_price || 0).toFixed(2)}
                              </td>
                              <td>
                                {item.closing_price
                                  ? `₹${Number(item.closing_price).toFixed(2)}`
                                  : "-"}
                              </td>
                              <td
                                className={
                                  itemPnl >= 0
                                    ? "text-success fw-bold"
                                    : "text-danger fw-bold"
                                }
                              >
                                ₹{Number(itemPnl || 0).toFixed(2)}
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    item.position_status === "CLOSED"
                                      ? "bg-secondary"
                                      : "bg-success"
                                  }`}
                                >
                                  {item.position_status}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {orderItems.length === 0 && (
                <div className="text-center text-muted py-3">
                  <p>No order items found for this strategy.</p>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

const OrderList = ({ isSidebarOpen = true }) => {
  const token = Cookies.get("authToken");
  const [orderData, setOrderData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Modal State
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Filter states
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    status: "",
    search: "",
    limit: 10,
    page: 1,
    offset: 0,
  });

  // Pagination info
  const [pagination, setPagination] = useState({
    totalCount: 0,
    hasMore: false,
  });

  const timezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";

  useEffect(() => {
    if (token) {
      getData();
    }
  }, [token, filters.limit, filters.page]);

  const validateDates = () => {
    if (filters.startDate) {
      if (dayjs(filters.startDate).isAfter(dayjs(), "day")) {
        toast.error("Start date cannot be in the future");
        return false;
      }

      if (!filters.endDate) {
        toast.error("End date is required when start date is selected");
        return false;
      }
    }

    if (filters.endDate) {
      if (dayjs(filters.endDate).isAfter(dayjs(), "day")) {
        toast.error("End date cannot be in the future");
        return false;
      }

      if (
        filters.startDate &&
        dayjs(filters.endDate).isBefore(dayjs(filters.startDate))
      ) {
        toast.error("End date cannot be before start date");
        return false;
      }
    }

    return true;
  };

  const getData = async () => {
    if (!validateDates()) return;

    setLoading(true);
    try {
      const currentOffset = (filters.page - 1) * filters.limit;

      const params = new URLSearchParams({
        timezone: timezone,
        limit: filters.limit.toString(),
        offset: currentOffset.toString(),
        page: filters.page.toString(),
      });

      if (filters.search) {
        params.append("search", filters.search);
      }
      if (filters.startDate) {
        params.append(
          "startDate",
          dayjs(filters.startDate).format("YYYY-MM-DD"),
        );
      }
      if (filters.endDate) {
        params.append("endDate", dayjs(filters.endDate).format("YYYY-MM-DD"));
      }

      if (filters.status) {
        params.append("status", filters.status);
      }

      const { data } = await api.get(
        `/ai/strategies/book?${params.toString()}`,
      );

      if (data.status === "success") {
        setOrderData(data.data);
        setPagination({
          totalCount: data.totalCount,
          hasMore: data.pagination?.hasMore || false,
        });

        setFilters((prev) => ({ ...prev, offset: currentOffset }));
      } else {
        toast.error(data.message || "Failed to fetch orders");
        setOrderData([]);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error.response?.data?.message || "Error fetching data");
      setOrderData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (field === "startDate" && !value) {
      setFilters((prev) => ({
        ...prev,
        startDate: "",
        endDate: "",
      }));
    }
  };

  const handleLimitChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      limit: parseInt(value),
      page: 1,
    }));
  };

  const handlePageChange = (value) => {
    const totalPages = Math.ceil(pagination.totalCount / filters.limit);
    if (value < 1 || value > totalPages) return;
    setFilters((prev) => ({
      ...prev,
      page: value,
    }));
  };

  const applyFilters = () => {
    setFilters((prev) => ({ ...prev, page: 1 }));
    setTimeout(() => getData(), 100);
  };

  const resetFilters = () => {
    setFilters((prev) => ({
      startDate: "",
      endDate: "",
      status: "",
      search: "",
      limit: prev.limit,
      page: 1,
      offset: 0,
    }));
    setTimeout(() => getData(), 100);
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const totalPages = Math.ceil(pagination.totalCount / filters.limit);

  const paginationRange = () => {
    const totalPageCount = totalPages;
    const siblingCount = 1;
    const boundaryCount = 3;

    if (totalPageCount <= 10) {
      const range = [];
      for (let i = 1; i <= totalPageCount; i++) range.push(i);
      return range;
    }

    const leftSiblingIndex = Math.max(filters.page - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      filters.page + siblingCount,
      totalPageCount,
    );

    const shouldShowLeftDots = leftSiblingIndex > boundaryCount + 1;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = 3 + 2 * siblingCount;
      let leftRange = [];
      for (let i = 1; i <= Math.max(leftItemCount, rightSiblingIndex); i++)
        leftRange.push(i);
      return [...leftRange, "...", totalPageCount];
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = 3 + 2 * siblingCount;
      let rightRange = [];
      for (
        let i = totalPageCount - rightItemCount + 1;
        i <= totalPageCount;
        i++
      )
        rightRange.push(i);
      return [1, 2, 3, "...", ...rightRange];
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      let middleRange = [];
      for (let i = leftSiblingIndex; i <= rightSiblingIndex; i++)
        middleRange.push(i);
      return [1, 2, 3, "...", ...middleRange, "...", totalPageCount];
    }
  };

  return (
    <>
      <div
        className={`${
          isSidebarOpen ? "col-lg-9" : "col-lg-12"
        } pt-4 pb-2 pb-sm-4`}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <h1 className="h3 mb-0 text-gray-800">Trade Book</h1>
              </div>
            </div>

            <div className="col-12">
              <div className="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
                <div className="card-body">
                  <h6 className="fw-bold mb-3">Filters</h6>
                  <div className="row g-3">
                    <div className="col-12 col-md-3">
                      <label className="form-label small text-muted mb-1">
                        Search
                      </label>
                      <div className="input-group input-group-sm p-0">
                        <span className="input-group-text">
                          <LuSearch />
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Strategy name..."
                          value={filters.search}
                          onChange={(e) =>
                            handleFilterChange("search", e.target.value)
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") applyFilters();
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label className="form-label small text-muted mb-1">
                        Start Date
                      </label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={filters.startDate}
                        max={dayjs().format("YYYY-MM-DD")}
                        onChange={(e) =>
                          handleFilterChange("startDate", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label className="form-label small text-muted mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={filters.endDate}
                        min={filters.startDate}
                        max={dayjs().format("YYYY-MM-DD")}
                        disabled={!filters.startDate}
                        onChange={(e) =>
                          handleFilterChange("endDate", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                      <label className="form-label small text-muted mb-1">
                        Status
                      </label>
                      <select
                        className="form-select form-select-sm"
                        value={filters.status}
                        onChange={(e) =>
                          handleFilterChange("status", e.target.value)
                        }
                      >
                        <option value="">All</option>
                        <option value="OPEN">OPEN</option>
                        <option value="CLOSED">CLOSED</option>
                        <option value="FAILED">FAILED</option>
                      </select>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3 d-flex align-items-end">
                      <div className="d-flex gap-2 w-100">
                        <button
                          className="btn btn-sm btn-primary w-50"
                          onClick={applyFilters}
                          disabled={loading}
                        >
                          {loading ? "..." : "Apply"}
                        </button>
                        <button
                          className="btn btn-sm btn-outline-primary w-50"
                          onClick={resetFilters}
                          disabled={loading}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="text-muted small">
                <strong>Total Strategies: {pagination.totalCount}</strong>
                <span className="mx-2">|</span>
                Showing{" "}
                {Math.min(
                  (filters.page - 1) * filters.limit + 1,
                  pagination.totalCount,
                )}{" "}
                -{" "}
                {Math.min(filters.page * filters.limit, pagination.totalCount)}
              </div>
              <div className="text-muted small">
                Page {filters.page} of {totalPages || 1}
              </div>
            </div>
          </div>

          <div className="col-12">
            <section className="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
              <div className="card-body">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted mt-2">Loading data...</p>
                  </div>
                ) : orderData.length === 0 ? (
                  <div className="text-center py-5">
                    <h5 className="text-muted">
                      No strategies found. Try adjusting your filters.
                    </h5>
                  </div>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead>
                          <tr>
                            <th className="rounded-start ps-3">#</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Invested</th>
                            <th>P/L</th>
                            <th>Items</th>
                            <th>Created At</th>
                            <th className="text-end rounded-end pe-3">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData.map((order, index) => {
                            const displayPnl =
                              order.status === "CLOSED"
                                ? order.realized_pnl || order.pnl
                                : order.pnl;
                            return (
                              <tr key={order.id || index}>
                                <td className="ps-3">
                                  {(filters.page - 1) * filters.limit +
                                    index +
                                    1}
                                </td>
                                <td>{order.strategy_type || "N/A"}</td>
                                <td>
                                  <span
                                    className={`badge ${
                                      order.status === "CLOSED"
                                        ? "bg-secondary"
                                        : order.status === "OPEN"
                                        ? "bg-success"
                                        : "bg-warning"
                                    } `}
                                  >
                                    {order.status}
                                  </span>
                                </td>
                                <td className="fw-medium">
                                  {order.invested_amount
                                    ? `₹${Number(order.invested_amount).toFixed(
                                        2,
                                      )}`
                                    : "-"}
                                </td>
                                <td
                                  className={`${
                                    displayPnl >= 0
                                      ? "text-success"
                                      : "text-danger"
                                  } fw-bold`}
                                >
                                  ₹{Number(displayPnl || 0).toFixed(2)}
                                </td>
                                <td>
                                  <span className="badge bg-info">
                                    {order.order_items?.length || 0}
                                  </span>
                                </td>
                                <td className="text-nowrap">
                                  {order.created_at || "-"}
                                </td>
                                <td className="">
                                  <button
                                    className="btn btn-sm btn-outline-info"
                                    onClick={() => handleViewDetails(order)}
                                  >
                                    <FaEye />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex align-items-center justify-content-between pt-3 pb-2 px-3 border-top">
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-body-secondary fs-sm">Show</span>
                        <select
                          className="form-select form-select-sm form-select-flush"
                          style={{ width: "auto" }}
                          value={filters.limit}
                          onChange={(e) => handleLimitChange(e.target.value)}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                        </select>
                      </div>

                      <nav aria-label="Page navigation">
                        <ul className="pagination pagination-sm mb-0">
                          <li
                            className={`page-item ${
                              filters.page === 1 ? "disabled" : ""
                            } `}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(filters.page - 1)}
                              aria-label="Prev"
                            >
                              <LuChevronLeft className="fs-xl me-1" /> Prev
                            </button>
                          </li>

                          {paginationRange()?.map((p, idx) => (
                            <li
                              key={idx}
                              className={`page-item ${
                                p === filters.page ? "active" : ""
                              } ${p === "..." ? "disabled" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  p !== "..." && handlePageChange(p)
                                }
                                style={{
                                  cursor: p === "..." ? "default" : "pointer",
                                }}
                              >
                                {p}
                              </button>
                            </li>
                          ))}

                          <li
                            className={`page-item ${
                              filters.page === totalPages || totalPages === 0
                                ? "disabled"
                                : ""
                            } `}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(filters.page + 1)}
                              aria-label="Next"
                            >
                              Next <LuChevronRight className="fs-xl ms-1" />
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Modal Integration */}
      <StrategyDetailsModal
        order={selectedOrder}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default OrderList;
